import { useState, useEffect } from "react";
import { useSearchParams  } from "react-router-dom";
import Home from "./Home";

const findCategory = (categories, postType) => {
    const category = categories.find((category) => category.postType === postType);
    return category ? category : categories[0];
}

const findLabel = (labels, label) => {
    if (!labels || !labels.length) return '';
    const curLabel = labels.find(l => l.value == label);
    return curLabel ? curLabel.value : labels[0].value;
}

const HomeContainer = ({ usePinPost, categories, postLabels = []}) => {
    const [ searchParams, setSearchParams ] = useSearchParams();
    const type = searchParams.get('postType');
    const label = searchParams.get('postLabel');
    const [ category, setCategory ] = useState(findCategory(categories, type));
    const [ curLabel, setCurLabel ] = useState(findLabel(postLabels, label));
    
    const handleCategoryChange = cate => {
        setSearchParams({ postType: cate.postType });
    }

    const handleLabelChange = label => {
        setCurLabel(label.value);
        setSearchParams({ postType: category.postType, postLabel: label.value });
    }

    useEffect(() => {
        const newCategory = findCategory(categories, type);
        setCategory(newCategory);
        if (type !== newCategory.postType) setCurLabel(postLabels.length ? postLabels[0].value : '');
    }, [type]);

    return (
        <Home postType={category.postType} postLabel={curLabel} usePinPost={usePinPost} postSectionTitle={category.sectionTitle}> 
            <div class="section-header">
                <ul class="section-tablist">
                    {categories.map( (cate) => (
                        <li className={cate.postType === category.postType ? 'active' : ''} 
                            onClick={() => handleCategoryChange(cate)} 
                            key={cate.postType}
                        >
                           {cate.title}
                        </li>
                    ))}
                </ul>
            </div>
            {postLabels.length > 0 && <div class="section-category">
                <ul>
                    {postLabels.map( (label) => (
                        <li className={label.value === curLabel ? 'active' : ''} 
                            onClick={() => handleLabelChange(label)} 
                            key={label.value}
                        >
                            {label.name}
                        </li>
                    ))}
                </ul>
            </div>}
        </Home>
    )
}

export default HomeContainer;